import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  icon: {
    fill: "#eee",
    color: theme.palette.text.primary
  },
  iconActive: {
    fill: theme.palette.secondary.dark
  }
}));
